import variablesStyles from '/styles/variables.css'

export const BREAKPOINTS = {
  TABLET: parseInt(variablesStyles.breakpointTablet, 10),
  LAPTOP: parseInt(variablesStyles.breakpointLaptop, 10),
  DESKTOP: parseInt(variablesStyles.breakpointDesktop, 10),
  ULTRA: parseInt(variablesStyles.breakpointUltra, 10),
  ULTRAHD: parseInt(variablesStyles.breakpointUltraHd, 10)
}
